// extracted by mini-css-extract-plugin
export var integrationButton = "_as-0";